//手持机名字校验
export const PubChecknull = (rule, value, callback) => {
  callback()
}
//手持机名字校验
export const PubCheckName = (rule, value, callback) => {
  let regEn = /[`~!@#$%^&*()+<>?:"{},=.\/;'[\]]/im,
    regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im
  if (!value) {
    callback(new Error('请输入设备名称'))
  }
  if (regEn.test(value) || regCn.test(value)) {
    callback(new Error('请输入正确设备名称'))
  }
  if (value.length > 20) {
    callback(new Error('请输入正确设备名称,不能超过20个字符'))
  }
  callback()
}


// 校验一码通地点码
export const PubCheckLocationCode = (rule, value, callback) => {
  let regEn = /[`~!@#$%^&*()+<>?:"{},=.\/;'[\]]/im,
    regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im,
    regNum = /^[0-9]*$/im
  if (!value) {
    callback(new Error('请输入一码通地点码'))
  }
  if (regEn.test(value) || regCn.test(value)) {
    callback(new Error('请输入正确一码通地点码'))
  }
  if (!regNum.test(value)) {
    callback(new Error('请输入正确一码通地点码'))
  }
  callback()
}


// 校验地址
export const PubCheckAddress = (rule, value, callback) => {
  let regEn = /[`~!@#$%^&*()+<>?:"{}=\/;'[\]]/im,
    regCn = /[·！#￥（——）：；“”‘|《》？、【】[\]]/im
  if (!value) {
    callback(new Error('请输入地址'))
  } else if (regEn.test(value) || regCn.test(value)) {
    callback(new Error('请输入正确地址'))
  }
  callback()
}

// 校验型号
export const PubCheckDeviceModel = (rule, value, callback) => {
  let regEn = /[`~!@#$%^&*()<>?:"{}=,.\/;'[\]]/im,
    regCn = /[·！#￥（）：；“”‘、，|《。》？、【】[\]]/im
  if (!value) {
    callback(new Error('请输入型号'))
  }
  if (regEn.test(value) || regCn.test(value)) {
    callback(new Error('请输入正确型号'))
  }
  callback()
}

// 密码校验
export const PubCheckPwd = (rule, value, callback) => {
  let reg = /^[0-9]{6}$/
  if (!value) {
    callback(new Error('请输入6位数字密码'))
  } else if (value && !reg.test(value)) {
    callback(new Error('请输入6位数字密码'))
  } else if (value && reg.test(value)) {
    callback()
  }
  callback()
}

// IP地址校验
export const PubCheckIP = (rule, value, callback) => {
  let reg = /^((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3}$/
  if (!value) {
    callback(new Error('请输入本地IP'))
  } else if (value && !reg.test(value)) {
    callback(new Error('请输入正确格式的IP, 例192.168.1.1'))
  } else if (value && reg.test(value)) {
    callback()
  }
  callback()//
}
